import { SalesChannelDetailPage } from '@/features/sales-channel/pages/SalesChannelDetailPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/sales-channel/$id/detail')({
  component: SalesChannelDetailPage,
})
